import './style.css';
const Post = ({url, title, children}) => {
    return (
        <div className="cardPost_style_2" dir="rtl">
            <div className="cartSectionImage_style_2">
                <img src={url} className='postImage_style_2' />
            </div>
            <div className="postDesctiption_style_2">
            <div className='imagePublishing'>
                    <img src='/image/Doctor/1$1658213511.jpg' />
                </div>
                <div className='dateTime'>
                    <b><p className='d-inline-block ps-2 pb-0 m-0' >منتشر: </p>
                    <p className='d-inline-block pb-0 m-0'>1401/08/12</p></b>
                </div>
                <hr  style={{marginTop: "-1px", marginRight: "35px", marginLeft: "35px", marginBottom: "10px"}}></hr>
                <h6 style={{marginTop: "-0px", zIndex: 999, padding: "5px"}}><b>{title}</b></h6>
                
                <p style={{fontSize: "12px", paddingTop: "5px", height: "35px", MaxHeight: "35px", color: "rgb(125, 125, 125)"}}>
                    {children}
                </p>
                <button className="btnPost_style_2">مشاهده</button>
            </div>
        </div>
    )
}

export default Post;